<template>
    <div class="registration-content">
        <!-- 页面标题区 -->
        <!-- <section class="bg-gradient-to-r from-[#1565C0] to-[#0D47A1] py-16 text-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <h2 class="text-4xl font-bold mb-4">数据资产登记</h2>
                <p class="text-lg text-blue-100 opacity-90 max-w-2xl">
                    通过标准化流程对数据资产进行全周期登记管理。构建企业级数据资产目录，实现自动化元数据采集与智能分类，并基于区块链技术建立可信溯源体系，确保数据来源、流转与变更记录的真实、完整与不可篡改，为后续的价值评估、合规审计及资产化运营奠定信任基础。
                </p>
                
            </div>
            
        </section> -->
        <section class="bg-gradient-to-r from-[#0D47A1] to-[#1976D2] py-20 text-white">
            <div class="max-w-[1200px] mx-auto px-4 flex items-center justify-between">
                <div class="max-w-2xl">

                    <h2 class="text-4xl font-bold mb-6">数据资产登记</h2>
                    <p class="text-xl text-blue-100 leading-relaxed opacity-90">
                        通过标准化流程对数据资产进行登记管理。构建企业级数据资产目录，实现自动化元数据采集与智能分类，并基于区块链技术建立可信溯源体系，确保数据来源、流转与变更记录的真实、完整与不可篡改，为后续的价值评估、合规审计及资产化运营奠定信任基础。
                    </p>
                    <div class="mt-8">
                        <div class="stat-card">
                           <!--
                            <div class="stat-icon-wrap">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stat-icon">
                                    <ellipse cx="12" cy="5" rx="8" ry="3" stroke="currentColor" stroke-width="1.8"/>
                                    <path d="M4 5v5c0 1.657 3.582 3 8 3s8-1.343 8-3V5" stroke="currentColor" stroke-width="1.8"/>
                                    <path d="M4 10v5c0 1.657 3.582 3 8 3s8-1.343 8-3v-5" stroke="currentColor" stroke-width="1.8"/>
                                    <path d="M4 15v4c0 1.657 3.582 3 8 3s8-1.343 8-3v-4" stroke="currentColor" stroke-width="1.8"/>
                                </svg>
                            </div>
                            -->
                            <div class="stat-body">
                                <p class="stat-label">已接入数据总量</p>
                                <p class="stat-value">
                                    <span class="stat-number">{{ displayCount.toLocaleString() }}</span>
                                    <span class="stat-unit">条</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden lg:block">
                    <span class="iconify text-[160px] text-white/20" data-icon="ri:database-2-line"></span>
                </div>
            </div>
        </section>


        <!-- 登记信息公示模块 -->
        <section id="publicity-section" class="py-16 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">

                <h3 class="text-2xl font-bold text-center mb-4">
                    <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                    信息公示
                </h3>
                <div class="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
                    <!-- 查询头部 -->
                    <div
                        class="p-6 border-b border-gray-100 flex flex-col md:flex-row md:items-center justify-between gap-4">
                        <h3 class="text-xl font-bold border-l-4 border-[#1565C0] pl-4">登记公示</h3>
                        <div class="flex items-center space-x-2">
                            <div class="relative">
                                <input v-model="searchValue"
                                    class="max-w-[300px] pl-4 pr-10 py-2 bg-gray-50 border border-gray-200 rounded text-sm outline-none focus:border-[#1565C0] transition-all"
                                    placeholder="搜索数据名称或登记主体" type="text" />
                                <span class="iconify absolute right-3 top-2.5 text-gray-400"
                                    data-icon="ri:search-line"></span>
                            </div>
                            <button @click="handleSearch"
                                class=" whitespace-nowrap bg-[#1565C0] text-white px-6 py-2 rounded text-sm font-medium hover:bg-[#0D47A1] transition-colors">查询</button>
                        </div>
                    </div>

                    <!-- 加载状态 -->
                    <div v-if="loading" class="flex flex-col items-center justify-center py-16">
                        <div class="relative">
                            <!-- 外圈旋转动画 -->
                            <div class="w-16 h-16 border-4 border-blue-100 rounded-full"></div>
                            <div
                                class="w-16 h-16 border-4 border-[#1565C0] border-t-transparent rounded-full animate-spin absolute top-0 left-0">
                            </div>
                            <!-- 内圈旋转动画 -->
                            <div class="w-10 h-10 border-3 border-blue-200 rounded-full absolute top-3 left-3"></div>
                            <div
                                class="w-10 h-10 border-3 border-blue-400 border-b-transparent rounded-full animate-spin-reverse absolute top-3 left-3">
                            </div>
                        </div>
                        <p class="mt-6 text-gray-600 font-medium">正在加载公示数据...</p>
                        <p class="text-sm text-gray-400 mt-2">请稍候，正在获取最新登记信息</p>
                    </div>

                    <!-- 数据表格（带过渡效果） -->
                    <div v-else class="overflow-x-auto fade-in">
                        <table class="w-full text-left text-sm border-collapse">
                            <thead>
                                <tr class="bg-blue-50/50 text-[#666666]">
                                    <th class="px-6 py-4 font-semibold border-b">数据资产名称</th>
                                    <th class="px-6 py-4 font-semibold border-b">登记主体</th>
                                    <th class="px-6 py-4 font-semibold border-b hidden sm:table-cell">所属行业</th>
                                    <th class="px-6 py-4 font-semibold border-b hidden sm:table-cell">登记时间</th>
                                    <th class="px-6 py-4 font-semibold border-b text-center">操作</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100">
                                <tr v-for="(item, index) in dataList" :key="item.certificateId" @click="showDetail(item)"
                                    class="hover:bg-gray-50 transition-colors fade-in-row"
                                    :style="{ animationDelay: `${index * 0.05}s` }">
                                    <td class="px-6 py-4 text-[#1565C0] font-medium hover:underline cursor-pointer">
                                        <span>{{ item.assetName }}</span>
                                        <span v-if="isExpired(item.effectiveDate)"
                                            class="ml-2 inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-red-100 text-red-600 border border-red-200">
                                            已过期
                                        </span>
                                        <span v-else-if="item.publicityEndTime == null"
                                            class="ml-2 inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-700 border border-yellow-300">
                                            公示中
                                        </span>
                                    </td>
                                    <td class="px-6 py-4">{{ item.companyName }}</td> 
                                    <td class="px-6 py-4 hidden sm:table-cell">{{ item.dataSource }}</td>
                                    <td class="px-6 py-4 hidden sm:table-cell">{{ item.registrationDate ||
                                        formatDate(item.createTime) }}</td>
                                    <td class="px-6 py-4 text-center space-x-2">
                                        <button @click="showDetail(item)"
                                            class="text-[#1565C0] hover:underline">详情</button>
                                        <!-- 根据状态字段决定是否显示异议申诉按钮 -->
                                        <!-- <button v-if="item.state !== '已颁发证书'" @click="fileAppeal(item)"
                                            class="text-red-500 hover:underline">异议申诉</button> -->
                                    </td>
                                </tr>
                                <tr v-if="dataList.length === 0" class="fade-in">
                                    <td colspan="6" class="px-6 py-8 text-center text-gray-500">
                                        暂无数据
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- 分页控件 -->
                    <div class="p-6 bg-gray-50 flex flex-col sm:flex-row items-center justify-between gap-4">
                        <div class="text-xs text-[#999999]">{{ updateDate }}</div>

                        <div class="flex items-center space-x-4">
                            <span class="text-sm text-[#666666] hidden sm:inline-block">
                                共 {{ total }} 条记录，第 {{ currentPage }} 页 / 共 {{ totalPages }} 页
                            </span>

                            <div class="flex items-center space-x-2">
                                <!-- 上一页按钮 -->
                                <button @click="prevPage" :disabled="currentPage <= 1" :class="[
                                    'px-3 py-1.5 border rounded text-sm font-medium transition-colors flex items-center',
                                    currentPage <= 1
                                        ? 'border-gray-300 text-gray-400 cursor-not-allowed bg-gray-50'
                                        : 'border-[#1565C0] text-[#1565C0] hover:bg-[#1565C0] hover:text-white hover:shadow-sm'
                                ]">
                                    <span class="iconify mr-1" data-icon="ri:arrow-left-s-line"></span>
                                    上一页
                                </button>

                                <!-- 页码显示区域 -->
                                <div class="flex items-center space-x-1">
                                    <template v-if="totalPages <= 7">
                                        <button v-for="page in totalPages" :key="page" @click="goToPage(page)" :class="[
                                            'w-8 h-8 flex items-center justify-center rounded text-sm font-medium transition-colors',
                                            page === currentPage
                                                ? 'bg-[#1565C0] text-white shadow-sm'
                                                : 'text-[#666666] hover:bg-gray-100 hover:text-[#1565C0]'
                                        ]">
                                            {{ page }}
                                        </button>
                                    </template>
                                    <template v-else>
                                        <!-- 显示前几页 -->
                                        <button v-for="page in Math.min(3, currentPage - 1)" :key="page"
                                            @click="goToPage(page)"
                                            class="w-8 h-8 flex items-center justify-center rounded text-sm font-medium text-[#666666] hover:bg-gray-100 hover:text-[#1565C0] transition-colors">
                                            {{ page }}
                                        </button>

                                        <!-- 省略号 -->
                                        <span v-if="currentPage > 4"
                                            class="w-8 h-8 flex items-center justify-center text-gray-400">
                                            ...
                                        </span>

                                        <!-- 当前页及前后页 -->
                                        <button v-if="currentPage > 3 && currentPage < totalPages - 2"
                                            @click="goToPage(currentPage - 1)"
                                            class="w-8 h-8 flex items-center justify-center rounded text-sm font-medium text-[#666666] hover:bg-gray-100 hover:text-[#1565C0] transition-colors">
                                            {{ currentPage - 1 }}
                                        </button>

                                        <button @click="goToPage(currentPage)"
                                            class="w-8 h-8 flex items-center justify-center rounded text-sm font-medium bg-[#1565C0] text-white shadow-sm">
                                            {{ currentPage }}
                                        </button>

                                        <button v-if="currentPage < totalPages - 2" @click="goToPage(currentPage + 1)"
                                            class="w-8 h-8 flex items-center justify-center rounded text-sm font-medium text-[#666666] hover:bg-gray-100 hover:text-[#1565C0] transition-colors">
                                            {{ currentPage + 1 }}
                                        </button>

                                        <!-- 省略号 -->
                                        <span v-if="currentPage < totalPages - 3"
                                            class="w-8 h-8 flex items-center justify-center text-gray-400">
                                            ...
                                        </span>

                                        <!-- 显示后几页 -->
                                        <button
                                            v-for="page in [...Array(Math.min(3, totalPages - currentPage)).keys()].map(n => totalPages - 2 + n)"
                                            :key="page" @click="goToPage(page)"
                                            class="w-8 h-8 flex items-center justify-center rounded text-sm font-medium text-[#666666] hover:bg-gray-100 hover:text-[#1565C0] transition-colors">
                                            {{ page }}
                                        </button>
                                    </template>
                                </div>

                                <!-- 下一页按钮 -->
                                <button @click="nextPage" :disabled="currentPage >= totalPages" :class="[
                                    'px-3 py-1.5 border rounded text-sm font-medium transition-colors flex items-center',
                                    currentPage >= totalPages
                                        ? 'border-gray-300 text-gray-400 cursor-not-allowed bg-gray-50'
                                        : 'border-[#1565C0] text-[#1565C0] hover:bg-[#1565C0] hover:text-white hover:shadow-sm'
                                ]">
                                    下一页
                                    <span class="iconify ml-1" data-icon="ri:arrow-right-s-line"></span>
                                </button>

                                <!-- 跳转到指定页码 -->
                                <div class="flex items-center space-x-2 ml-2">
                                    <span class="text-sm text-[#666666] hidden md:inline-block">跳至</span>
                                    <div class="relative">
                                        <input v-model="jumpPage" type="number" min="1" :max="totalPages"
                                            @keyup.enter="jumpToPage"
                                            class="w-16 px-2 py-1.5 border border-gray-300 rounded text-sm text-center outline-none focus:border-[#1565C0] focus:ring-1 focus:ring-[#1565C0]"
                                            placeholder="页码" />
                                    </div>
                                    <button @click="jumpToPage"
                                        class="px-3 py-1.5 bg-gray-100 text-[#666666] rounded text-sm font-medium hover:bg-gray-200 transition-colors">
                                        确定
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 核心功能展示 -->
        <section class="py-16 bg-gradient-to-r bg-gray-50 to-indigo-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="mb-12 text-center">
                    <h3 class="text-3xl font-bold mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>

                        核心功能
                    </h3>
                </div>
                <div class="core-features-grid">
                    <div class="core-feature-card">
                        <div class="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-[#1565C0] text-3xl" data-icon="ri:article-line"></span>
                        </div>
                        <h4 class="feature-title">资源权属登记</h4>
                        <p class="feature-description">
                            支持各级政府部门及公共企事业单位进行数据资源初始登记，明确数据管理权、持有权与经营权。
                        </p>
                    </div>
                    <div class="core-feature-card">
                        <div class="w-14 h-14 bg-green-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-[#00BFA5] text-3xl" data-icon="ri:shield-check-line"></span>
                        </div>
                        <h4 class="feature-title">合规性审查</h4>
                        <p class="feature-description">
                            内置自动化审查工具与人工复核机制，确保登记数据的来源可溯、内容合法、授权清晰。
                        </p>
                    </div>
                    <div class="core-feature-card">
                        <div class="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-[#2196F3] text-3xl" data-icon="ri:qr-code-line"></span>
                        </div>
                        <h4 class="feature-title">登记凭证发放</h4>
                        <p class="feature-description">
                            完成登记后自动生成全国统一标识的数据资源登记凭证，作为数据资产入表及流通交易的权威证明。
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 登记流程指南 -->
        <section class="py-16 bg-white overflow-hidden">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <h3 class="text-3xl font-bold mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>

                        登记流程
                    </h3>
                    <p class="text-[#999999]">SIMPLE &amp; STANDARD REGISTRATION PROCESS</p>
                </div>
                <div class="flex justify-between relative mt-10">
                    <!-- 连线装饰 -->
                    <div class="absolute top-10 left-0 w-full h-0.5 bg-gray-100 -z-0"></div>
                    <div class="relative z-10 flex flex-col items-center w-1/5">
                        <div
                            class="w-20 h-20 rounded-full bg-[#1565C0] flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg shadow-blue-100">
                            01</div>
                        <h5 class="font-bold text-lg mb-2">企业认证</h5>
                        <p class="text-center text-[#666666] text-sm px-4 leading-relaxed">实名认证主体身份，确保登记主体资质合法有效</p>
                    </div>
                    <div class="relative z-10 flex flex-col items-center w-1/5">
                        <div
                            class="w-20 h-20 rounded-full bg-[#1565C0] flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg shadow-blue-100">
                            02</div>
                        <h5 class="font-bold text-lg mb-2">资产登记</h5>
                        <p class="text-center text-[#666666] text-sm px-4 leading-relaxed">在线填报数据元数据、权属来源及合规性说明</p>
                    </div>
                    <div class="relative z-10 flex flex-col items-center w-1/5">
                        <div
                            class="w-20 h-20 rounded-full bg-[#1565C0] flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg shadow-blue-100">
                            03</div>
                        <h5 class="font-bold text-lg mb-2">专家审核</h5>
                        <p class="text-center text-[#666666] text-sm px-4 leading-relaxed">平台组织行业专家及法律顾问进行实质性核查</p>
                    </div>
                    <div class="relative z-10 flex flex-col items-center w-1/5">
                        <div
                            class="w-20 h-20 rounded-full bg-[#1565C0] flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg shadow-blue-100">
                            04</div>
                        <h5 class="font-bold text-lg mb-2">信息公示</h5>
                        <p class="text-center text-[#666666] text-sm px-4 leading-relaxed">审核通过后进入<span
                                class="text-[#E53935] font-semibold">3天</span>公示期，接受社会各方监督</p>
                    </div>
                    <div class="relative z-10 flex flex-col items-center w-1/5">
                        <div
                            class="w-20 h-20 rounded-full bg-[#00BFA5] flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg shadow-teal-100">
                            05</div>
                        <h5 class="font-bold text-lg mb-2">颁发证书</h5>
                        <p class="text-center text-[#666666] text-sm px-4 leading-relaxed">公示期无异议后，在线核发全国统一的登记凭证</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 登记发证的核心价值 -->
        <section class="py-16 bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="mb-12 text-center">
                    <h3 class="text-2xl font-bold">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        价值优势
                    </h3>
                </div>
                <div class="value-advantages-grid">
                    <div class="value-advantage-card">
                        <span class="iconify text-[#1565C0] text-3xl mb-4" data-icon="ri:shield-keyhole-line"></span>
                        <h6 class="value-advantage-title">权属边界清晰</h6>
                        <p class="value-advantage-description">
                            通过法定程序明确数据资产的所有权、持有权与经营权，减少法律纠纷。
                        </p>
                    </div>
                    <div class="value-advantage-card">
                        <span class="iconify text-[#1565C0] text-3xl mb-4" data-icon="ri:medal-line"></span>
                        <h6 class="value-advantage-title">提升数据公信力</h6>
                        <p class="value-advantage-description">
                            国家平台背书，经专家审核机制验证，显著提升数据资产的品牌价值与市场认可度。
                        </p>
                    </div>
                    <div class="value-advantage-card">
                        <span class="iconify text-[#1565C0] text-3xl mb-4" data-icon="ri:exchange-funds-line"></span>
                        <h6 class="value-advantage-title">促进高效流通</h6>
                        <p class="value-advantage-description">
                            统一标识符与权威凭证，简化合规尽调流程，降低交易成本，加速要素入表与流通。
                        </p>
                    </div>
                    <div class="value-advantage-card">
                        <span class="iconify text-[#1565C0] text-3xl mb-4" data-icon="ri:safe-2-line"></span>
                        <h6 class="value-advantage-title">规范化管理</h6>
                        <p class="value-advantage-description">
                            将非结构化资源转化为标准化资产，实现公共数据资源"一本账"精细化运营。
                        </p>
                    </div>
                </div>
            </div>
        </section>


        <!-- 快速操作入口 -->
        <section class="py-16 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="mb-12 text-center">
                    <h3 class="text-2xl font-bold">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>

                        操作入口
                    </h3>
                    <p class="text-[#666666] mt-4 max-w-2xl mx-auto">选择适合您的操作方式，快速开启数据资产登记与管理</p>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                    <!-- 在线登记 -->
                    <div
                        class="bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-xl border border-gray-100 text-center">
                        <div
                            class="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 mx-auto shadow-md">
                            <span class="iconify text-[#1565C0] text-2xl" data-icon="ri:edit-box-line"></span>
                        </div>
                        <h4 class="text-xl font-bold mb-4">在线登记</h4>
                        <p class="text-[#666666] text-sm mb-6">全新数据资产的首次登记，建立权属关系</p>
                        <button @click="toDataAssetRegister"
                            class="bg-[#1565C0] hover:bg-[#0D47A1] text-white px-6 py-3 rounded-lg font-medium w-full transition-all">
                            开始登记
                        </button>
                    </div>

                    <!-- 进度查询 -->
                    <div
                        class="bg-gradient-to-br from-green-50 to-teal-50 p-8 rounded-xl border border-gray-100 text-center">
                        <div
                            class="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 mx-auto shadow-md">
                            <span class="iconify text-[#00BFA5] text-2xl" data-icon="ri:file-search-line"></span>
                        </div>
                        <h4 class="text-xl font-bold mb-4">进度查询</h4>
                        <p class="text-[#666666] text-sm mb-6">查询已提交登记申请的数据资产审核进度与状态</p>
                        <button @click="toDataAssetRegisterDetail"
                            class="bg-[#00BFA5] hover:bg-[#00897B] text-white px-6 py-3 rounded-lg font-medium w-full transition-all">
                            查询进度
                        </button>
                    </div>

                    <!-- 证书管理 -->
                    <div
                        class="bg-gradient-to-br from-purple-50 to-blue-50 p-8 rounded-xl border border-gray-100 text-center">
                        <div
                            class="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 mx-auto shadow-md">
                            <span class="iconify text-[#7B1FA2] text-2xl" data-icon="ri:honour-line"></span>
                        </div>
                        <h4 class="text-xl font-bold mb-4">证书管理</h4>
                        <p class="text-[#666666] text-sm mb-6">查看、下载和管理已颁发的数据资产登记证书</p>
                        <button @click="toDataAssetRegisterDetail"
                            class="bg-[#7B1FA2] hover:bg-[#6A1B9A] text-white px-6 py-3 rounded-lg font-medium w-full transition-all">
                            管理证书
                        </button>
                    </div>
                </div>

            </div>
        </section>


        <!-- 辅助工具与资源 -->
        <section class="py-16 bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="mb-12 text-center">
                    <h3 class="text-2xl font-bold">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        辅助工具与资源
                    </h3>
                    <p class="text-[#666666] mt-4 max-w-2xl mx-auto">提供全面的辅助工具和资源，帮助您顺利完成数据资产登记</p>
                </div>

                <div class="bg-white rounded-2xl p-8 shadow-sm">
                    <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
                        <div class="text-center group cursor-pointer">
                            <div
                                class="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4 mx-auto group-hover:bg-blue-100 transition-colors">
                                <span class="iconify text-[#1565C0] text-3xl group-hover:scale-110 transition-transform"
                                    data-icon="ri:book-open-line"></span>
                            </div>
                            <h5 class="font-bold text-lg mb-2 text-gray-800">操作手册</h5>
                            <p class="text-sm text-gray-600">详细的操作指南与示例</p>
                            <div class="mt-3">
                                <router-link to="/registration-guide"
                                    class="text-[#1565C0] text-sm hover:underline inline-flex items-center">
                                    查看详情
                                    <span class="iconify ml-1" data-icon="ri:arrow-right-s-line"></span>
                                </router-link>
                            </div>
                        </div>

                        <div class="text-center group cursor-pointer">
                            <div
                                class="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4 mx-auto group-hover:bg-green-100 transition-colors">
                                <span class="iconify text-[#00BFA5] text-3xl group-hover:scale-110 transition-transform"
                                    data-icon="ri:question-line"></span>
                            </div>
                            <h5 class="font-bold text-lg mb-2 text-gray-800">常见问题</h5>
                            <p class="text-sm text-gray-600">登记过程中的常见疑问解答</p>
                            <div class="mt-3">
                                <router-link to="/websiteFAQ"
                                    class="text-[#00BFA5] text-sm hover:underline inline-flex items-center">
                                    查看FAQ
                                    <span class="iconify ml-1" data-icon="ri:arrow-right-s-line"></span>
                                </router-link>
                            </div>
                        </div>

                        <div class="text-center group cursor-pointer">
                            <div
                                class="w-16 h-16 bg-purple-50 rounded-full flex items-center justify-center mb-4 mx-auto group-hover:bg-purple-100 transition-colors">
                                <span class="iconify text-[#7B1FA2] text-3xl group-hover:scale-110 transition-transform"
                                    data-icon="ri:customer-service-2-line"></span>
                            </div>
                            <h5 class="font-bold text-lg mb-2 text-gray-800">在线客服</h5>
                            <p class="text-sm text-gray-600">专业顾问一对一指导</p>
                            <div class="mt-3">
                                <a @click="showMessageModal = true"
                                    class="text-[#7B1FA2] text-sm hover:underline inline-flex items-center">
                                    联系客服
                                    <span class="iconify ml-1" data-icon="ri:arrow-right-s-line"></span>
                                </a>
                            </div>
                        </div>

                        <div class="text-center group cursor-pointer">
                            <div
                                class="w-16 h-16 bg-orange-50 rounded-full flex items-center justify-center mb-4 mx-auto group-hover:bg-orange-100 transition-colors">
                                <span class="iconify text-[#FF9800] text-3xl group-hover:scale-110 transition-transform"
                                    data-icon="ri:file-download-line"></span>
                            </div>
                            <h5 class="font-bold text-lg mb-2 text-gray-800">材料清单</h5>
                            <p class="text-sm text-gray-600">标准化的登记材料模板文件</p>
                            <div class="mt-3">
                                <a href="#" class="text-[#FF9800] text-sm hover:underline inline-flex items-center">
                                    下载文件
                                    <span class="iconify ml-1" data-icon="ri:arrow-right-s-line"></span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- 额外资源链接 -->
                    <!-- <div class="mt-12 pt-8 border-t border-gray-200">
                        <div class="flex flex-wrap justify-center gap-6">
                            <a href="#" class="text-gray-600 hover:text-[#1565C0] text-sm flex items-center">
                                <span class="iconify mr-2" data-icon="ri:file-text-line"></span>
                                政策法规
                            </a>
                            <a href="#" class="text-gray-600 hover:text-[#1565C0] text-sm flex items-center">
                                <span class="iconify mr-2" data-icon="ri:video-line"></span>
                                视频教程
                            </a>
                            <a href="#" class="text-gray-600 hover:text-[#1565C0] text-sm flex items-center">
                                <span class="iconify mr-2" data-icon="ri:calendar-line"></span>
                                培训日程
                            </a>
                            <a href="#" class="text-gray-600 hover:text-[#1565C0] text-sm flex items-center">
                                <span class="iconify mr-2" data-icon="ri:newspaper-line"></span>
                                行业动态
                            </a>
                        </div>
                    </div> -->
                </div>
            </div>
        </section>

        <!-- 异议申诉对话框 -->
        <div v-if="showAppealDialog" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl">
                <!-- 对话框头部 -->
                <div class="p-6 border-b border-gray-100">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <div class="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center mr-4">
                                <span class="iconify text-red-500 text-xl" data-icon="ri:alert-line"></span>
                            </div>
                            <div>
                                <h3 class="text-xl font-bold text-gray-800">异议申诉</h3>
                                <p class="text-sm text-gray-500 mt-1">对数据资产 "<span class="font-medium text-[#1565C0]">{{
                                    appealItem?.assetName }}</span>" 提出异议</p>
                            </div>
                        </div>
                        <button @click="closeAppealDialog"
                            class="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors">
                            <span class="iconify text-gray-400 text-xl hover:text-gray-600"
                                data-icon="ri:close-line"></span>
                        </button>
                    </div>
                </div>

                <!-- 对话框内容 -->
                <div class="p-6 max-h-[70vh] overflow-y-auto">
                    <form @submit.prevent="submitAppeal">
                        <!-- 基本信息展示 -->
                        <div class="mb-6 bg-blue-50/50 rounded-lg p-4 border border-blue-100">
                            <div class="grid grid-cols-2 gap-4">
                                <div>
                                    <p class="text-xs text-gray-500 mb-1">登记主体</p>
                                    <p class="font-medium text-gray-800">{{ appealItem?.companyName }}</p>
                                </div>
                                <div>
                                    <p class="text-xs text-gray-500 mb-1">所属行业</p>
                                    <p class="font-medium text-gray-800">{{ appealItem?.dataSource }}</p>
                                </div>
                                <div>
                                    <p class="text-xs text-gray-500 mb-1">登记时间</p>
                                    <p class="font-medium text-gray-800">{{ appealItem?.registrationDate ||
                                        formatDate(appealItem?.createTime) }}</p>
                                </div>
                                <div>
                                    <p class="text-xs text-gray-500 mb-1">登记编号</p>
                                    <p class="font-medium text-gray-800">{{ appealItem?.certificateId }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- 申诉类型选择 -->
                        <div class="mb-6">
                            <label class="block text-sm font-medium text-gray-700 mb-3">
                                <span class="text-red-500 mr-1">*</span>
                                申诉类型
                            </label>
                            <div class="grid grid-cols-4 gap-3">
                                <label v-for="type in appealTypes" :key="type.value"
                                    class="flex flex-col items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-200"
                                    :class="appealForm.type === type.value
                                        ? 'border-[#1565C0] bg-blue-50 shadow-sm'
                                        : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'">
                                    <input type="radio" v-model="appealForm.type" :value="type.value" class="hidden">
                                    <div class="w-10 h-10 rounded-full mb-3 flex items-center justify-center"
                                        :class="appealForm.type === type.value ? 'bg-[#1565C0]' : 'bg-gray-100'">
                                        <span class="iconify text-lg"
                                            :class="appealForm.type === type.value ? 'text-white' : 'text-gray-500'"
                                            :data-icon="type.icon"></span>
                                    </div>
                                    <span class="font-medium text-gray-800 text-sm mb-1">{{ type.label }}</span>
                                    <span class="text-xs text-gray-500 text-center">{{ type.description }}</span>
                                </label>
                            </div>
                        </div>

                        <!-- 申诉问题输入 -->
                        <div class="mb-6">
                            <div class="flex items-center justify-between mb-3">
                                <label class="block text-sm font-medium text-gray-700">
                                    <span class="text-red-500 mr-1">*</span>
                                    申诉问题描述
                                </label>
                                <span class="text-xs"
                                    :class="appealForm.content.length > 500 ? 'text-red-500' : 'text-gray-500'">
                                    {{ appealForm.content.length }}/500
                                </span>
                            </div>
                            <textarea v-model="appealForm.content" placeholder="请详细描述您的异议问题，包括具体事实、理由和相关依据..."
                                class="w-full h-40 px-4 py-3 border border-gray-300 rounded-lg text-sm resize-none outline-none focus:border-[#1565C0] focus:ring-2 focus:ring-blue-100 transition-all"
                                :class="{ 'border-red-300 focus:border-red-500 focus:ring-red-100': appealError.content }"
                                @input="appealError.content = ''"></textarea>
                            <div v-if="appealError.content" class="text-red-500 text-xs mt-2 flex items-center">
                                <span class="iconify mr-1" data-icon="ri:error-warning-line"></span>
                                {{ appealError.content }}
                            </div>
                            <p class="text-xs text-gray-500 mt-2">建议详细描述，不少于20字</p>
                        </div>

                        <div class="grid grid-cols-2 gap-6">
                            <!-- 联系方式 -->
                            <div class="mb-6">
                                <label class="block text-sm font-medium text-gray-700 mb-3">联系方式</label>
                                <div class="relative">
                                    <span
                                        class="iconify absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                                        data-icon="ri:contacts-line"></span>
                                    <input v-model="appealForm.contact" placeholder="请输入您的联系电话或邮箱"
                                        class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg text-sm outline-none focus:border-[#1565C0] focus:ring-2 focus:ring-blue-100 transition-all">
                                </div>
                                <p class="text-xs text-gray-500 mt-2">填写后便于我们及时与您沟通处理进展</p>
                            </div>

                            <!-- 附件上传 -->
                            <div class="mb-6">
                                <label class="block text-sm font-medium text-gray-700 mb-3">相关证明材料</label>

                                <!-- 上传区域 -->
                                <div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-[#1565C0] transition-colors cursor-pointer"
                                    @click="triggerFileUpload">
                                    <div
                                        class="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-2">
                                        <span class="iconify text-[#1565C0] text-xl"
                                            data-icon="ri:upload-cloud-2-line"></span>
                                    </div>
                                    <p class="text-sm text-gray-600 mb-1">点击上传证明材料</p>
                                    <p class="text-xs text-gray-400">支持图片、PDF、Word等格式，单个文件不超过10MB</p>
                                </div>



                                <input type="file" ref="fileInput" @change="handleFileUpload" class="hidden" multiple>
                            </div>
                        </div>

                        <!-- 已上传文件列表 -->
                        <div v-if="appealForm.files.length > 0" class="mb-6">
                            <label class="block text-sm font-medium text-gray-700 mb-3">已上传文件</label>
                            <div v-for="(file, index) in appealForm.files" :key="index"
                                class="border border-gray-200 rounded-lg p-3 bg-white hover:bg-gray-50 transition-colors">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center flex-1 min-w-0">
                                        <!-- 文件图标 -->
                                        <div
                                            class="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center mr-3">
                                            <span class="iconify text-[#1565C0]" :data-icon="getFileIcon(file)"></span>
                                        </div>

                                        <!-- 文件信息 -->
                                        <div class="flex-1 min-w-0">
                                            <div class="flex items-center justify-between mb-1">
                                                <p class="text-sm font-medium text-gray-800 truncate">{{
                                                    file.name }}
                                                </p>
                                                <span class="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded">{{
                                                    formatFileSize(file.size) }}</span>
                                            </div>

                                            <!-- 上传状态 -->
                                            <div class="flex items-center justify-between">
                                                <div class="flex items-center">
                                                    <span v-if="file.uploadStatus === 'success'"
                                                        class="text-xs text-green-600 flex items-center">

                                                        上传成功
                                                    </span>
                                                    <span v-else-if="file.uploadStatus === 'uploading'"
                                                        class="text-xs text-blue-600 flex items-center">

                                                        上传中...
                                                    </span>
                                                    <span v-else-if="file.uploadStatus === 'error'"
                                                        class="text-xs text-red-600 flex items-center">

                                                        上传失败
                                                    </span>
                                                    <span v-else class="text-xs text-gray-500">待上传</span>
                                                </div>

                                                <!-- 文件类型标签 -->
                                                <span class="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded">{{
                                                    getFileType(file) }}</span>
                                            </div>

                                            <!-- 上传进度条 -->
                                            <div v-if="file.uploadStatus === 'uploading'" class="mt-2">
                                                <div class="w-full bg-gray-200 rounded-full h-1.5">
                                                    <div class="bg-[#1565C0] h-1.5 rounded-full transition-all duration-300"
                                                        :style="{ width: file.progress + '%' }"></div>
                                                </div>
                                                <p class="text-xs text-gray-500 text-right mt-1">{{
                                                    file.progress }}%
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 操作按钮 -->
                                    <div class="ml-3 flex items-center space-x-2">
                                        <!-- 重新上传按钮（仅在上传失败时显示） -->
                                        <button v-if="file.uploadStatus === 'error'" @click.stop="retryUpload(index)"
                                            class="w-8 h-8 rounded-full hover:bg-blue-50 flex items-center justify-center transition-colors"
                                            title="重新上传">
                                            <span class="iconify text-blue-500" data-icon="ri:refresh-line"></span>
                                        </button>

                                        <!-- 删除按钮 -->
                                        <button @click.stop="removeFile(index)"
                                            class="w-8 h-8 rounded-full hover:bg-red-50 flex items-center justify-center transition-colors"
                                            title="删除文件">
                                            <span class="iconify text-red-500" data-icon="ri:close-line"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <!-- 注意事项 -->
                        <div class="mb-6 bg-yellow-50 border border-yellow-100 rounded-lg p-4">
                            <div class="flex items-start">
                                <span class="iconify text-yellow-500 mr-3 mt-0.5"
                                    data-icon="ri:information-line"></span>
                                <div>
                                    <p class="text-sm font-medium text-yellow-800 mb-1">重要提示</p>
                                    <ul class="text-xs text-yellow-700 space-y-1">
                                        <li>• 请确保申诉内容真实、准确，不得捏造事实</li>
                                        <li>• 平台将在3个工作日内处理您的申诉</li>
                                        <li>• 处理结果将通过系统消息通知</li>
                                        <li>• 恶意申诉将承担相应法律责任</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- 对话框底部 -->
                <div class="p-6 border-t border-gray-100 bg-gray-50 rounded-b-xl">
                    <div class="flex justify-between items-center">
                        <div class="text-xs text-gray-500">
                            <span class="iconify inline-block mr-1" data-icon="ri:shield-check-line"></span>
                            您的信息将严格保密
                        </div>
                        <div class="flex space-x-3">
                            <button @click="closeAppealDialog"
                                class="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors flex items-center">
                                <span class="iconify mr-2" data-icon="ri:close-circle-line"></span>
                                取消
                            </button>
                            <button @click="submitAppeal" :disabled="submittingAppeal"
                                class="px-6 py-2.5 bg-gradient-to-r from-[#1565C0] to-[#0D47A1] text-white rounded-lg font-medium hover:shadow-md transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center">
                                <span v-if="submittingAppeal" class="iconify animate-spin mr-2"
                                    data-icon="ri:loader-4-line"></span>
                                <span v-else class="iconify mr-2" data-icon="ri:send-plane-line"></span>
                                {{ submittingAppeal ? '提交中...' : '提交申诉' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 在线留言弹窗 -->
        <div v-if="showMessageModal"
            class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div class="bg-white rounded-2xl w-full max-w-md shadow-2xl">
                <!-- 弹窗头部 -->
                <div class="flex items-center justify-between p-6 border-b border-gray-100">
                    <div class="flex items-center space-x-3">
                        <div class="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-[#1565C0]">
                            <span class="iconify text-xl" data-icon="ri:message-3-line"></span>
                        </div>
                        <h3 class="text-xl font-bold text-gray-800">专家咨询</h3>
                    </div>
                    <button @click="showMessageModal = false"
                        class="text-gray-400 hover:text-gray-600 transition-colors">
                        <span class="iconify text-2xl" data-icon="ri:close-line"></span>
                    </button>
                </div>

                <!-- 表单内容 -->
                <div class="p-6">
                    <form @submit.prevent="submitMessage" class="space-y-5">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">姓名 <span
                                    style="color: red;">*</span></label>
                            <input v-model="messageForm.name" type="text" required
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入您的姓名">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">联系方式 <span
                                    style="color: red;">*</span></label>
                            <input v-model="messageForm.contact" type="text" required
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入手机号或邮箱">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">公司/机构</label>
                            <input v-model="messageForm.company" type="text"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入公司或机构名称（选填）">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">咨询内容 <span
                                    style="color: red;">*</span></label>
                            <textarea v-model="messageForm.content" required rows="4"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none"
                                placeholder="请简要描述您的数据资产价值评估咨询需求..."></textarea>
                        </div>

                        <div class="pt-2">
                            <button type="submit" :disabled="isSubmitting"
                                class="w-full bg-[#1565C0] text-white py-3 rounded-lg font-bold hover:bg-[#0D47A1] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                <span v-if="!isSubmitting">提交咨询</span>
                                <span v-else class="flex items-center justify-center">
                                    <span class="iconify animate-spin mr-2" data-icon="ri:loader-4-line"></span>
                                    提交中...
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- 提交成功提示 -->
        <div v-if="showSuccessToast" class="fixed top-6 right-6 z-50 animate-slide-in">
            <div class="bg-green-50 border border-green-200 rounded-xl p-4 shadow-lg flex items-center space-x-3">
                <div class="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                    <span class="iconify text-xl" data-icon="ri:checkbox-circle-fill"></span>
                </div>
                <div>
                    <p class="font-medium text-green-800">咨询提交成功！</p>
                    <p class="text-sm text-green-600">我们将尽快与您联系</p>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
export default {
    data() {
        return {
            searchValue: '',
            searchType: 'assetName', // 默认按数据资产名称搜索
            currentPage: 1,
            pageSize: 10,
            updateDate: '',
            dataList: [],
            total: 0,
            loading: false,
            allRecordCount: 0,
            displayCount: 0,
            jumpPage: '', //跳转页码输入
            showTable: false, // 控制表格显示

            // 异议申诉相关数据
            showAppealDialog: false,
            appealItem: null,
            submittingAppeal: false,
            appealForm: {
                type: 'ownership', // 默认选择权属问题
                content: '',
                contact: '',
                files: []
            },
            appealError: {
                content: ''
            },
            appealTypes: [
                {
                    value: 'ownership',
                    label: '权属问题',
                    description: '对数据所有权、使用权有异议'
                },
                {
                    value: 'authenticity',
                    label: '真实性',
                    description: '质疑数据来源或内容真实性'
                },
                {
                    value: 'compliance',
                    label: '合规性',
                    description: '认为数据存在合规风险'
                },
                {
                    value: 'other',
                    label: '其他',
                    description: '其他类型的问题'
                }
            ],
            // 新增数据
            showUploadSuccess: false,
            uploadSuccessTimer: null,

            // 新增留言相关数据
            showMessageModal: false,
            showSuccessToast: false,
            isSubmitting: false,
            messageForm: {
                name: '',
                contact: '',
                company: '',
                content: ''
            }
        }
    },
    mounted() {
        this.fetchData()
        this.fetchAllRecordCount()
    },
    computed: {
        totalPages() {
            return Math.ceil(this.total / this.pageSize);
        }
    },
    watch: {
        showAppealDialog(newVal) {
            if (newVal) {
                // 显示对话框时禁止body滚动
                document.body.style.overflow = 'hidden';
            } else {
                // 隐藏对话框时恢复body滚动
                document.body.style.overflow = '';
            }
        }
    },
    methods: {
        async fetchAllRecordCount() {
            try {
                const res = await this.$axios.get('/web/page/dataAssets/queryAllRecordCount')
                if (res.data && res.data.object != null) {
                    this.allRecordCount = res.data.object
                    this.animateCount(this.allRecordCount)
                }
            } catch (e) {
                console.error('获取数据总量失败', e)
            }
        },
        animateCount(target) {
            const duration = 800
            const start = 0
            const startTime = performance.now()
            const step = (currentTime) => {
                const elapsed = currentTime - startTime
                const progress = Math.min(elapsed / duration, 1)
                // easeOutExpo 缓动
                const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress)
                this.displayCount = Math.floor(ease * (target - start) + start)
                if (progress < 1) {
                    requestAnimationFrame(step)
                } else {
                    this.displayCount = target
                }
            }
            requestAnimationFrame(step)
        },
        isExpired(effectiveDate) {
            if (!effectiveDate) return false
            // 处理 "2026年5月23日" 格式
            const normalized = effectiveDate.replace(/(\d+)年(\d+)月(\d+)日/, '$1-$2-$3')
            const date = new Date(normalized)
            if (isNaN(date.getTime())) return false
            return date < new Date()
        },
        async fetchData() {
            try {
                this.loading = true;
                this.showTable = false; // 隐藏表格
                // console.log('正在获取数据，页码:', this.currentPage, '每页条数:', this.pageSize);

                const params = {
                    currPage: this.currentPage,
                    pageSize: this.pageSize
                };

                // 如果有搜索值，添加搜索参数
                if (this.searchValue) {
                    params[this.searchType] = this.searchValue;
                }

                const res = await this.$axios.get('/web/page/certificate/queryPublicityListWithSize', {
                    params,
                    paramsSerializer: params => {
                        return Object.entries(params)
                            .filter(([_, value]) => value !== undefined && value !== '')
                            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                            .join('&');
                    }
                });
                // 获取原始数据
                // const originalList = res.data?.list || [];

                // 打乱数据顺序
                // this.dataList = this.shuffleArray(originalList);
                this.dataList = res.data?.list || [];
                this.total = res.data?.total || 0;
                console.log(res);

                // 数据加载完成后，延迟显示表格以实现平滑过渡
                setTimeout(() => {
                    this.loading = false;
                    // 使用setTimeout确保DOM更新后再显示表格
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.showTable = true;
                        }, 50);
                    });
                }, 300); // 增加一点延迟让加载动画更明显

            } catch (error) {
                console.error('获取公示数据失败:', error);
                this.$message.error('获取公示数据失败');
            } finally {
                this.loading = false;
            }
        },

        handleSearch() {
            this.currentPage = 1;
            this.fetchData();
        },

        getStatusClass(status) {
            const statusColors = {
                '已颁发证书': 'bg-green-100 text-green-800',
                '审核中': 'bg-yellow-100 text-yellow-800',
                '已驳回': 'bg-red-100 text-red-800',
                '待审核': 'bg-blue-100 text-blue-800'
            };
            return `px-2 py-1 ${statusColors[status] || 'bg-gray-100 text-gray-700'} text-xs rounded`;
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
        },

        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.fetchData();
            }
        },

        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchData();
            }
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
                this.currentPage = page;
                this.fetchData();
            }
        },
        // 跳转到输入的页码
        jumpToPage() {
            const page = parseInt(this.jumpPage);
            if (!isNaN(page) && page >= 1 && page <= this.totalPages) {
                if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
                    this.currentPage = page;
                    this.fetchData();
                }
                this.jumpPage = '';
            } else {
                this.$message.warning(`请输入有效的页码（1-${this.totalPages}）`);
            }
        },
        showDetail(item) {
            // console.log('查看详情:', item);
            // 这里可以添加显示详情的逻辑，比如打开弹窗或跳转页面
            console.log(`查看详情: ${item.assetName}\n登记编号: ${item.registrationId || item.certificateId}`);
            this.$router.push(`/assetDetail/${item.registrationId}`)
        },
        // fileAppeal(item) {
        //     // console.log('异议申诉:', item);
        //     // 这里可以添加异议申诉的逻辑
        //     console.log(`对 "${item.assetName}" 提出异议申诉`);
        // },
        // fileAppeal(item) {
        //     console.log(`对 "${item.assetName}" 提出异议申诉`);
        //     this.appealItem = item;
        //     this.resetAppealForm();
        //     this.showAppealDialog = true;
        // },

        closeAppealDialog() {
            this.showAppealDialog = false;
            this.appealItem = null;
            this.resetAppealForm();
        },

        resetAppealForm() {
            this.appealForm = {
                type: 'ownership',
                content: '',
                contact: '',
                files: []
            };
            this.appealError = {
                content: ''
            };
            this.submittingAppeal = false;
        },

        validateAppealForm() {
            let isValid = true;

            // 验证问题描述
            if (!this.appealForm.content.trim()) {
                this.appealError.content = '请填写申诉问题描述';
                isValid = false;
            } else if (this.appealForm.content.trim().length < 20) {
                this.appealError.content = '问题描述至少需要20字';
                isValid = false;
            } else if (this.appealForm.content.length > 500) {
                this.appealError.content = '问题描述不能超过500字';
                isValid = false;
            }

            return isValid;
        },

        async submitAppeal() {
            if (!this.validateAppealForm()) {
                return;
            }

            try {
                this.submittingAppeal = true;

                // 构建提交数据
                const appealData = {
                    certificateId: this.appealItem.certificateId,
                    assetName: this.appealItem.assetName,
                    companyName: this.appealItem.companyName,
                    appealType: this.appealForm.type,
                    appealContent: this.appealForm.content,
                    contactInfo: this.appealForm.contact,
                    // 这里可以添加文件上传逻辑
                    files: this.appealForm.files
                };

                // console.log('提交申诉数据:', appealData);

                // 模拟API调用
                await new Promise(resolve => setTimeout(resolve, 1500));

                // 实际API调用示例：
                // const response = await this.$axios.post('/web/appeal/submit', appealData);

                this.$message.success('申诉提交成功！我们将在3个工作日内处理您的申诉');
                this.closeAppealDialog();

            } catch (error) {
                console.error('提交申诉失败:', error);
                this.$message.error('提交申诉失败，请稍后重试');
            } finally {
                this.submittingAppeal = false;
            }
        },

        triggerFileUpload() {
            this.$refs.fileInput.click();
        },

        async handleFileUpload(event) {
            const files = Array.from(event.target.files);

            // 验证文件大小和类型
            const validFiles = files.filter(file => {
                const maxSize = 10 * 1024 * 1024; // 10MB

                if (file.size > maxSize) {
                    this.$message.warning(`文件 "${file.name}" 超过10MB限制`);
                    return false;
                }

                // 检查文件类型
                const allowedExtensions = [
                    '.jpg', '.jpeg', '.png', '.gif', '.webp',
                    '.pdf',
                    '.doc', '.docx',
                    '.xls', '.xlsx'
                ];

                const fileName = file.name.toLowerCase();
                const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

                if (!isValidExtension) {
                    this.$message.warning(`文件 "${file.name}" 格式不支持，请上传图片、PDF、Word或Excel文件`);
                    return false;
                }

                return true;
            });

            if (validFiles.length === 0) {
                return;
            }

            // 为每个文件添加上传状态信息
            const filesWithStatus = validFiles.map(file => ({
                file: file, // 保留原始文件对象
                name: file.name,
                size: file.size,
                type: file.type,
                uploadStatus: 'pending', // pending, uploading, success, error
                progress: 0,
                id: Date.now() + Math.random().toString(36).substr(2, 9)
            }));

            // 添加到文件列表
            this.appealForm.files.push(...filesWithStatus);

            // 清空文件输入
            event.target.value = '';

            // 开始模拟上传
            this.simulateFileUpload(filesWithStatus);
        },
        simulateFileUpload(files) {
            files.forEach((file, index) => {
                const fileIndex = this.appealForm.files.findIndex(f => f.id === file.id);
                if (fileIndex === -1) return;

                // 更新状态为上传中
                this.$set(this.appealForm.files[fileIndex], 'uploadStatus', 'uploading');

                // 模拟上传进度
                let progress = 0;
                const interval = setInterval(() => {
                    progress += Math.random() * 20 + 10; // 每次增加10-30%
                    if (progress >= 100) {
                        progress = 100;
                        clearInterval(interval);

                        // 模拟上传成功
                        setTimeout(() => {
                            this.$set(this.appealForm.files[fileIndex], 'uploadStatus', 'success');
                            this.$set(this.appealForm.files[fileIndex], 'progress', 100);

                            // 显示上传成功提示
                            this.showUploadSuccessMessage();
                        }, 300);
                    } else {
                        this.$set(this.appealForm.files[fileIndex], 'progress', Math.min(progress, 99));
                    }
                }, 200);
            });
        },

        showUploadSuccessMessage() {
            // 清除之前的定时器
            if (this.uploadSuccessTimer) {
                clearTimeout(this.uploadSuccessTimer);
            }

            this.showUploadSuccess = true;

            // 5秒后自动隐藏提示
            this.uploadSuccessTimer = setTimeout(() => {
                this.showUploadSuccess = false;
            }, 5000);
        },

        retryUpload(index) {
            const file = this.appealForm.files[index];
            this.$set(this.appealForm.files[index], 'uploadStatus', 'uploading');
            this.$set(this.appealForm.files[index], 'progress', 0);

            // 模拟重新上传
            let progress = 0;
            const interval = setInterval(() => {
                progress += Math.random() * 30 + 20; // 每次增加20-50%
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);

                    setTimeout(() => {
                        this.$set(this.appealForm.files[index], 'uploadStatus', 'success');
                        this.$set(this.appealForm.files[index], 'progress', 100);
                        this.showUploadSuccessMessage();
                    }, 300);
                } else {
                    this.$set(this.appealForm.files[index], 'progress', Math.min(progress, 99));
                }
            }, 200);
        },

        removeFile(index) {
            if (index >= 0 && index < this.appealForm.files.length) {
                this.appealForm.files.splice(index, 1);

                // 如果删除了所有文件，隐藏成功提示
                if (this.appealForm.files.length === 0) {
                    this.showUploadSuccess = false;
                    if (this.uploadSuccessTimer) {
                        clearTimeout(this.uploadSuccessTimer);
                    }
                }
            }
        },

        getFileIcon(fileObj) {
            // 处理文件对象
            const file = fileObj.file || fileObj;
            if (!file) return 'ri:file-line';

            const type = file.type || '';
            const name = file.name || '';

            if (type.includes('image') || /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(name)) {
                return 'ri:image-line';
            }
            if (type.includes('pdf') || name.toLowerCase().endsWith('.pdf')) {
                return 'ri:file-pdf-line';
            }
            if (type.includes('word') || type.includes('document') || /\.(doc|docx)$/i.test(name)) {
                return 'ri:file-word-line';
            }
            if (type.includes('excel') || type.includes('spreadsheet') || /\.(xls|xlsx)$/i.test(name)) {
                return 'ri:file-excel-line';
            }
            return 'ri:file-line';
        },

        getFileType(file) {
            // 修复文件类型判断逻辑
            if (!file) return '文件';

            // 优先使用文件对象的type属性
            if (file.type) {
                if (file.type.includes('image')) return '图片';
                if (file.type.includes('pdf')) return 'PDF';
                if (file.type.includes('word') || file.type.includes('document')) return 'Word文档';
                if (file.type.includes('excel') || file.type.includes('spreadsheet')) return 'Excel文档';
            }

            // 如果type不存在，尝试通过文件名判断
            if (file.name) {
                const extension = file.name.split('.').pop().toLowerCase();
                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
                const pdfExtensions = ['pdf'];
                const wordExtensions = ['doc', 'docx'];
                const excelExtensions = ['xls', 'xlsx'];

                if (imageExtensions.includes(extension)) return '图片';
                if (pdfExtensions.includes(extension)) return 'PDF';
                if (wordExtensions.includes(extension)) return 'Word文档';
                if (excelExtensions.includes(extension)) return 'Excel文档';
            }

            return '文件';
        },

        formatFileSize(bytes) {
            // 修复文件大小格式化逻辑
            if (!bytes || isNaN(bytes) || bytes === 0) return '0 Bytes';

            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },


        // 跳转到资产登记申请  
        toDataAssetRegister() {
            this.$router.push('/index/data-registration');
        },
        // 跳转到资产登记申请 详情  
        toDataAssetRegisterDetail() {
            this.$router.push('/DataProperty');
        },

        async submitMessage() {
            if (this.isSubmitting) return;

            this.isSubmitting = true;

            try {
                // 构建咨询数据
                const consultationData = {
                    name: this.messageForm.name,
                    contact: this.messageForm.contact,
                    problemDescription: this.messageForm.content,
                    subjectName: this.messageForm.company || '未填写',
                    consultationTime: this.getCurrentTime(),
                    status: 0 // 默认未处理
                };

                console.log('提交咨询请求参数:', consultationData);

                // 调用API接口
                const response = await this.$axios.post('/web/consultation/save', consultationData);
                console.log('提交咨询响应:', response.data);

                if (response.data && response.data.status === 200) {
                    // 显示成功提示
                    this.showSuccessToast = true;

                    // 重置表单
                    this.messageForm = {
                        name: '',
                        contact: '',
                        company: '',
                        content: ''
                    };

                    // 关闭弹窗
                    this.showMessageModal = false;

                    // 3秒后自动隐藏成功提示
                    setTimeout(() => {
                        this.showSuccessToast = false;
                    }, 3000);
                } else {
                    this.$message.error(response.data?.msg || '提交咨询失败');
                }

            } catch (error) {
                console.error('提交咨询失败:', error);
                this.$message.error('提交咨询失败，请稍后重试');
            } finally {
                this.isSubmitting = false;
            }
        },

        // 获取当前时间（新增方法）
        getCurrentTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
    }
}
</script>

<style lang="scss" scoped>
.registration-content {
    .core-features-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
            gap: 1.5rem;
        }
    }

    .core-feature-card {
        background-color: white;
        padding: 2rem;
        border-radius: 0.5rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.3s ease;

        &:hover {
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
    }

    .feature-title {
        font-size: 1.25rem;
        font-weight: bold;
        margin-bottom: 1rem;
    }

    .feature-description {
        color: #666666;
        line-height: 1.6;
    }

    .value-advantages-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 1.5rem;

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
            gap: 1rem;
        }
    }

    .value-advantage-card {
        background-color: white;
        padding: 1.5rem;
        border-radius: 0.5rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.3s ease;
        border: 1px solid #f3f4f6;

        &:hover {
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
    }

    .value-advantage-title {
        font-weight: bold;
        margin-bottom: 0.5rem;
        font-size: 1rem;
    }

    .value-advantage-description {
        font-size: 0.875rem;
        color: #666666;
    }

    /* 分页控件样式优化 */
    .pagination-container {
        .page-btn {
            transition: all 0.2s ease;

            &:hover:not(:disabled) {
                transform: translateY(-1px);
            }

            &:active:not(:disabled) {
                transform: translateY(0);
            }
        }

        .current-page {
            box-shadow: 0 2px 4px rgba(21, 101, 192, 0.2);
        }

        input[type="number"] {

            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            -moz-appearance: textfield;
        }
    }

    // 淡入动画
    .fade-in {
        animation: fadeIn 0.6s ease-out forwards;
        opacity: 0;
    }

    .fade-in-row {
        animation: fadeInRow 0.5s ease-out forwards;
        opacity: 0;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes fadeInRow {
        from {
            opacity: 0;
            transform: translateX(-10px);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    // 反向旋转动画
    @keyframes spin-reverse {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(-360deg);
        }
    }

    .animate-spin-reverse {
        animation: spin-reverse 1s linear infinite;
    }

    // 表格行悬停效果增强
    tr.fade-in-row:hover {
        background-color: rgba(21, 101, 192, 0.05) !important;
        transform: translateX(2px);
        transition: all 0.2s ease;
    }

    .tools-resources-section {
        .resource-card {
            transition: all 0.3s ease;

            &:hover {
                transform: translateY(-5px);
            }
        }
    }

    /* 异议申诉对话框样式 */
    .appeal-dialog {
        animation: dialogFadeIn 0.3s ease-out;
    }

    @keyframes dialogFadeIn {
        from {
            opacity: 0;
            transform: translateY(-20px) scale(0.95);
        }

        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    /* 文件上传区域悬停效果 */
    .file-upload-area:hover {
        background-color: rgba(21, 101, 192, 0.05);
    }

    /* 单选按钮样式增强 */
    input[type="radio"]:checked+div {
        .radio-indicator {
            border-color: #1565C0;
        }
    }

    // 弹窗动画
    .fixed.inset-0 {
        animation: fadeIn 0.3s ease-out;

        .bg-white {
            animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
    }

    // 成功提示动画
    .animate-slide-in {
        animation: slideInRight 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(20px) scale(0.95);
        }

        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    @keyframes slideInRight {
        from {
            opacity: 0;
            transform: translateX(100%);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    // 响应式调整
    @media (max-width: 768px) {
        // ... existing responsive styles ...

        // 弹窗响应式
        .fixed.inset-0 {
            padding: 1rem;
            align-items: flex-end;

            .bg-white {
                width: 100%;
                max-width: 100%;
                border-radius: 1rem 1rem 0 0;
                animation: slideUpMobile 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            }
        }

        @keyframes slideUpMobile {
            from {
                transform: translateY(100%);
            }

            to {
                transform: translateY(0);
            }
        }

        // 成功提示响应式
        .fixed.top-6.right-6 {
            top: auto;
            bottom: 1rem;
            right: 1rem;
            left: 1rem;
            animation: slideUpMobile 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
    }

    // 平板设备适配
    @media (min-width: 769px) and (max-width: 1024px) {
        .fixed.inset-0 {
            .bg-white {
                max-width: 90%;
            }
        }
    }

}

.stat-card {
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255,255,255,0.25);
    border-radius: 1.25rem;
    padding: 1rem 1.75rem;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.2);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 32px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.2);
    }

    .stat-icon-wrap {
        width: 2.75rem;
        height: 2.75rem;
        background: rgba(255,255,255,0.18);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);

        .stat-icon {
            width: 1.4rem;
            height: 1.4rem;
            color: #fff;
        }
    }

    .stat-body {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;

        .stat-label {
            font-size: 0.72rem;
            color: rgba(186, 214, 255, 0.9);
            letter-spacing: 0.08em;
            line-height: 1;
        }

        .stat-value {
            display: flex;
            align-items: baseline;
            gap: 0.3rem;
            line-height: 1;

            .stat-number {
                font-size: 2rem;
                font-weight: 700;
                color: #fff;
                font-variant-numeric: tabular-nums;
                letter-spacing: -0.02em;
            }

            .stat-unit {
                font-size: 0.9rem;
                font-weight: 400;
                color: rgba(186, 214, 255, 0.85);
            }
        }
    }
}
</style>